import React from "react"
import styles from "./BlockImgRightFloatingText.module.css"
const BlockImgRightFloatingText = ({ bgColor, data }) => {
  const {
    title,
    text,
    img: {
      uri: { url: image },
    },
  } = data
  return (
    <section className={styles.blockImgRightFloatingText}>
      <div className={styles.blockImgRightFloatingText__text}>
        <p>{title}</p>
      </div>
      <div className={styles.blockImgRightFloatingText__img}>
        <img src={`https://drupal.smartempo.com${image}`} alt={title} />
      </div>
      <div className={styles.blockImgRightFloatingText__titleText}>
        <p>{text}</p>
      </div>
    </section>
  )
}
export default BlockImgRightFloatingText
